export const GET_PRODUCT = "GET_PRODUCT";
export const ADD_TO_CART = "ADD_TO_CART";
export const PRODUCT_TYPE = "PRODUCT_TYPE";
